// Dream photos are stored inside the dream's document as a JPEG data URL, so they need no file
// storage. A Firestore document holds at most 1 MiB, so photos are shrunk to fit well under that.
export const MAX_SIDE = 1200;
// About 300 KB of photo: a Dreamboard of 10 dreams stays near 4 MB on a phone.
export const MAX_DATA_URL_LENGTH = 400_000;

// The size to draw a w × h image at so its longer side is at most `max`, keeping its shape.
export const fitWithin = (w, h, max = MAX_SIDE) => {
  const scale = Math.min(1, max / Math.max(w, h));
  return { width: Math.round(w * scale), height: Math.round(h * scale) };
};

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("That file isn't a photo we can open.")); };
  img.src = url;
});

// Shrinks a picked photo to a JPEG data URL under MAX_DATA_URL_LENGTH, lowering quality and then
// size until it fits.
export async function resizeImage(file) {
  const img = await loadImage(file);
  let side = MAX_SIDE;
  for (let attempt = 0; attempt < 4; attempt += 1) {
    const { width, height } = fitWithin(img.naturalWidth, img.naturalHeight, side);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
    for (const quality of [0.82, 0.7, 0.58]) {
      const url = canvas.toDataURL("image/jpeg", quality);
      if (url.length <= MAX_DATA_URL_LENGTH) return url;
    }
    side = Math.round(side * 0.75);
  }
  throw new Error("That photo is too large to save. Try a smaller one.");
}
